module.exports = __webpack_public_path__ + "img/user-profile.d30e15a2.png";